












































































































import { Component, Mixins } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { resolveModule } from '@/store';
import { EventsModule } from '@/store/dashboard/events/EventsModule';
import { NotificationInterface } from '@/store/dashboard/notifications/notifications';
import { EventListRequestInterface } from '@/modules/backend';
import DataTableWrapper from '@/layouts/DataTableWrapper.vue';
import { DataTableHeader } from 'vuetify';
import Mixin from '@/mixins/base';
import SortMixin from '@/mixins/sort';
import { eventTypeToString } from '@/filters/eventTypeToString';
import { CompaniesModule } from '@/store/dashboard/companies/CompaniesModule';
import ProvidersModule from '@/store/dashboard/providers/ProvidersModule';
import { Event } from '@/modules/backend/Entities/Event';

const NotificationsModule = namespace('dashboard/notifications');
@Component({
  mixins: [Mixin, SortMixin],
  filters: {
    eventTypeToString
  },
  components: {
    'data-table-wrapper': DataTableWrapper
  }
})
export default class Notifications extends Mixins(Mixin, SortMixin) {
  private readonly eventsModule: EventsModule = resolveModule(EventsModule);
  private readonly companiesModule: CompaniesModule = resolveModule(CompaniesModule);
  private readonly providersModule: ProvidersModule = resolveModule(ProvidersModule);
  private readonly chosenCompanies: number[] = [];
  private readonly chosenProviders: number[] = [];

  @NotificationsModule.Getter('Notifications')
  private readonly Notifications!: NotificationInterface[];

  @NotificationsModule.Action('MarkAsRead')
  private readonly MarkAsRead!: (payload: NotificationInterface) => Promise<void>;

  @NotificationsModule.Action('Fetch')
  private readonly LoadNotifications!: (payload: EventListRequestInterface) => Promise<void>;

  private loading = false;
  private readonly limit: number = 10000;

  private get headers(): DataTableHeader[] {
    return [
      {
        text: this.isDesktop ? this.$t('common.table.headers.id').toString() : this.$t('common.table.headers.id_short').toString(),
        sortable: false,
        value: 'Id'
      },
      {
        text: this.$i18n.t('screens.events.table.headers.event').toString(),
        value: 'Event'
      },
      {
        text: this.$i18n.t('screens.events.table.headers.object').toString(),
        value: 'Building'
      },
      {
        text: this.$i18n.t('screens.events.table.headers.account').toString(),
        value: 'Account'
      },
      {
        text: this.$i18n.t('screens.events.table.headers.counter').toString(),
        value: 'Counter'
      },
      {
        text: this.$i18n.t('screens.events.table.headers.date').toString(),
        value: 'date'
      },
    ];
  }

  private async eventFilterCompany(payload: number[]): Promise<void> {
    await this.eventsModule.fetch({
      companyIds: payload,
      providerIds: this.chosenProviders,
      limit: this.limit,
      offset: 0
    });
  }

  private async eventFilterProviders(payload: number[]): Promise<void> {
    await this.eventsModule.fetch({
      companyIds: this.chosenCompanies,
      providerIds: payload,
      limit: this.limit,
      offset: 0
    });
  }

  private get eventList(): Event[] {
    return this.eventsModule.events;
  }

  private async loadData(): Promise<void> {
    this.loading = true;

    await Promise.all([
      this.eventsModule.fetch({
        limit: this.limit,
        offset: 0
      }),
      this.providersModule.fetch(),
    ]);

    this.loading = false;
  }

  public async mounted(): Promise<void> {
    await this.loadData();
  }

  private getEventName(event: Event): string {
    const name = event.getDetails();
    if (name) {
      return name;
    }

    return '—';
  }

  private getEventBuilding(event: Event): string {
    const street = event.getCounter().getAccount().getLocation().getBuilding().getAddress().getStreet();
    const name = event.getCounter().getAccount().getLocation().getBuilding().getAddress().getName();
    const building = street + name;

    if (building) {
      return building;
    }

    return '—';
  }

  private getEventAccount(event: Event): string {
    const account = event.getCounter().getAccount().getContent();

    if (account) {
      return account;
    }

    return '—';
  }

  private getEventCounter(event: Event): string {
    const counter = event.getCounter().getStamp();

    if (counter) {
      return counter;
    }

    return '—';
  }

  private getEventDate(event: Event): Date {
    return event.createdAt;
  }

  private customSort(items: Event[], index: string[], isDescending: boolean[]): Event[] {
    items.sort((a, b): number => {
      if (index[0] === 'Event') {
        return this.stringComparator(
          this.getEventName(a),
          this.getEventName(b),
          isDescending[0]
        );
      }

      if (index[0] === 'Building') {
        return this.stringComparator(
          this.getEventBuilding(a),
          this.getEventBuilding(b),
          isDescending[0]
        );
      }

      if (index[0] === 'Account') {
        return this.stringComparator(
          this.getEventAccount(a),
          this.getEventAccount(b),
          isDescending[0]
        );
      }

      if (index[0] === 'Counter') {
        return this.stringComparator(
          this.getEventCounter(a),
          this.getEventCounter(b),
          isDescending[0]
        );
      }

      if (index[0] === 'date') {
        return this.dateComparator(
          this.getEventDate(a),
          this.getEventDate(b),
          isDescending[0]
        );
      }

      return 0;
    });

    return items;
  }
}
